<template>
  <div class="relative">
    <button
        type="button"
        class="flex items-center justify-between w-full h-11 px-3 border border-stroke-separator rounded-lg bg-transparent text-text-neutral-extreme outline-none focus:border-elements-blue cursor-pointer"
        @click="open = !open"
    >
      <span>{{ languageName }}</span>
      <img src="@/assets/icons/chevron-down-white.svg" class="w-4 h-4" alt="" />
    </button>

    <div
        v-if="open"
        class="absolute z-20 mt-2 w-full max-w-[320px] bg-layer-2 border border-stroke-separator rounded-lg shadow-lg p-3"
    >
      <language-picker :initial="props.modelValue" :close-on-select="false" :show-flags="false" @select="onSelect"></language-picker>
    </div>
    <div v-if="open" class="fixed inset-0 z-10" @click="open = false"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, defineEmits } from 'vue'
import LanguagePicker from '@/components/session/LanguagePicker.vue'
import { useLanguages } from '@/composables/useLanguages'

const props = defineProps<{ modelValue: string }>()
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const emit = defineEmits<{ (event: 'update:modelValue', code: string): void }>()

const { getLanguageName } = useLanguages()

const open = ref(false)
const languageName = computed(() => getLanguageName(props.modelValue))

function onSelect(code: string) {
  emit('update:modelValue', code)
  open.value = false
}
</script>
